import Vue from "vue";
import Router from "vue-router";
import Reservation from "./views/Reservation.vue";
import TransactionChecker from "./views/TransactionChecker.vue";

Vue.use(Router);

var bookNowPath = '/book-now'
if(window.reservationConfiguration != null) {
  if(window.reservationConfiguration.bookNowUrl != null) {
    bookNowPath = window.reservationConfiguration.bookNowUrl
  }
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/book-now",
      alias: '/nl/boek-nu',
      name: "reservation",
      component: Reservation,
      children: [
        {
          path: "reservation/:stepID",
          component: Reservation
        },
      ]
    },
    {
      path: "/book-now",
      alias: '/scooter/nl/boek-nu',
      name: "reservation",
      component: Reservation,
      children: [
        {
          path: "reservation/:stepID",
          component: Reservation
        },
      ]
    },
    {
      path: "/book-now",
      alias: '/scuba/nl/boek-nu',
      name: "reservation",
      component: Reservation,
      children: [
        {
          path: "reservation/:stepID",
          component: Reservation
        },
      ]
    },
    {
      path: "/ecowheels/book-now",
      alias: '/ecowheels/nl/boek-nu',
      name: "reservation",
      component: Reservation,
      children: [
        {
          path: "reservation/:stepID",
          component: Reservation
        },
      ]
    },
    {
      path: "/book-now",
      alias: bookNowPath,
      name: "reservation",
      component: Reservation,
      children: [
        {
          path: "reservation/:stepID",
          component: Reservation
        },
      ]
    },
    {
      path: "/book-now/success",
      alias: '/nl/boek-nu/success',
      name: "transactionchecker",
      component: TransactionChecker,
      props: route => ({ token: route.query.transaction_token })
    },
    {
      path: "/book-now",
      alias: "/de/buchen-sie-jetzt",
      name: "reservation",
      component: Reservation,
      children: [
        {
          path: "reservation/:stepID",
          component: Reservation
        },
      ]
    },
    {
      path: "/book-now/success",
      alias: '/de/buchen-sie-jetzt/erfolg',
      name: "transactionchecker",
      component: TransactionChecker,
      props: route => ({ token: route.query.transaction_token })
    },
  ]
});

export default router